/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegistrationsControllerNormalizeEmailMutationRequest, RegistrationsControllerNormalizeEmailMutationResponse, RegistrationsControllerNormalizeEmail401, RegistrationsControllerNormalizeEmail403, RegistrationsControllerNormalizeEmail404 } from "../../models/registrationsController/RegistrationsControllerNormalizeEmail";

function getRegistrationsControllerNormalizeEmailUrl() {
  const res = { method: 'POST', url: `/api/v1/registrations/normalize-email` as const }  
  return res
}

/**
 * @description Creates a lowercase Cognito account for users who registered with mixed-case emails. Verifies the password against the existing account before creating the normalized copy.
 * @summary Normalize a Cognito user email to lowercase
 * {@link /api/v1/registrations/normalize-email}
 */
export async function registrationsControllerNormalizeEmail(data?: RegistrationsControllerNormalizeEmailMutationRequest, config: Partial<RequestConfig<RegistrationsControllerNormalizeEmailMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<RegistrationsControllerNormalizeEmailMutationResponse, ResponseErrorConfig<RegistrationsControllerNormalizeEmail401 | RegistrationsControllerNormalizeEmail403 | RegistrationsControllerNormalizeEmail404>, RegistrationsControllerNormalizeEmailMutationRequest>({ method : "POST", url : getRegistrationsControllerNormalizeEmailUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}